'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var PeerId = require('peer-id');

var _require = require('multiaddr'),
    Multiaddr = _require.Multiaddr;

var mafmt = require('mafmt');

var _require2 = require('events'),
    EventEmitter = _require2.EventEmitter;

var debug = require('debug');

var log = Object.assign(debug('libp2p:bootstrap'), {
  error: debug('libp2p:bootstrap:error')
});
/**
 * Emits 'peer' events on a regular interval for each peer in the provided list.
 */

var Bootstrap = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Bootstrap, _EventEmitter);

  var _super = _createSuper(Bootstrap);

  /**
   * Constructs a new Bootstrap.
   *
   * @param {Object} options
   * @param {Array<string>} options.list - the list of peer addresses in multi-address format
   * @param {number} [options.interval = 10000] - the interval between emitting addresses in milliseconds
   *
   */
  function Bootstrap() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      list: []
    };

    _classCallCheck(this, Bootstrap);

    if (!options.list || !options.list.length) {
      throw new Error('Bootstrap requires a list of peer addresses');
    }

    _this = _super.call(this);
    _this._list = options.list;
    _this._interval = options.interval || 10000;
    _this._timer = null;
    return _this;
  }
  /**
   * Start emitting events.
   */


  _createClass(Bootstrap, [{
    key: "start",
    value: function start() {
      var _this2 = this;

      if (this._timer) {
        return;
      }

      this._timer = setInterval(function () {
        return _this2._discoverBootstrapPeers();
      }, this._interval);
      log('Starting bootstrap node discovery');

      this._discoverBootstrapPeers();
    }
    /**
     * Emit each address in the list as a PeerInfo.
     */

  }, {
    key: "_discoverBootstrapPeers",
    value: function _discoverBootstrapPeers() {
      var _this3 = this;

      if (!this._timer) {
        return;
      }

      this._list.forEach(function (candidate) {
        if (!mafmt.P2P.matches(candidate)) {
          return log.error('Invalid multiaddr');
        }

        var ma = new Multiaddr(candidate);
        var peerIdStr = ma.getPeerId();

        if (!peerIdStr) {
          log.error('Invalid bootstrap multiaddr without peer id');
          return;
        }

        var peerId = PeerId.createFromB58String(peerIdStr);

        try {
          _this3.emit('peer', {
            id: peerId,
            multiaddrs: [ma]
          });
        } catch (err) {
          log.error('Invalid bootstrap peer id', err);
        }
      });
    }
    /**
     * Stop emitting events.
     */

  }, {
    key: "stop",
    value: function stop() {
      if (this._timer) clearInterval(this._timer);
      this._timer = null;
    }
  }]);

  return Bootstrap;
}(EventEmitter);

exports = module.exports = Bootstrap;
exports.tag = 'bootstrap';